import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBottomNav from "@/components/MobileBottomNav";
import GiftConcierge from "@/components/GiftConcierge";
import { annotateExternalAffiliateLinks, logExternalAffiliateAnchor } from "@/lib/clickTracking";

const Layout = ({ children, hideConcierge }: { children: ReactNode; hideConcierge?: boolean }) => {
  const location = useLocation();

  useEffect(() => {
    annotateExternalAffiliateLinks();

    const observer = new MutationObserver(() => {
      annotateExternalAffiliateLinks();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const anchor = target.closest<HTMLAnchorElement>("a[href]");
      if (!anchor) {
        return;
      }

      logExternalAffiliateAnchor(anchor);
    };

    document.addEventListener("click", handleDocumentClick, true);

    return () => {
      observer.disconnect();
      document.removeEventListener("click", handleDocumentClick, true);
    };
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pb-16 lg:pb-0">{children}</main>
      <Footer />
      <MobileBottomNav />
      {!hideConcierge && <GiftConcierge />}
    </div>
  );
};

export default Layout;
